import React from "react"

import Container from "../components/Container"
import awsBadge from "../assets/aws.png"
import hhBadge from "../assets/hh.png"
import az900Badge from "../assets/az900.png"
import dp900Badge from "../assets/dp900.png"
import aiKnowledgeMiningBadge from "../assets/aiknowledgemining.png"
import readyPlayer50Badge from "../assets/ready.png"
import snowflakeGenAIBadge from "../assets/snowflake-gen-ai.png"
import datacampDEAssociateBadge from "../assets/datacamp-de-associate.png"
import datacampDEBadge from "../assets/datacamp-de.png"

export default function Achievements() {
    return (
        <Container>
            <article id="achievements" className="wrapper">
                <h1>Achievements</h1>

                <section className="badges first-row">
                    <a href="https://raw.githubusercontent.com/VincentLeV/demo-gifs-storage/main/certs/datacamp-de/DE0017277432437.jpg" target="_blank" rel="noreferrer">
                        <img className="round" src={datacampDEBadge} alt="Datacamp Data Engineer Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://raw.githubusercontent.com/VincentLeV/demo-gifs-storage/main/certs/datacamp-de-associate/DataCamp-DEA0012434809631.jpg" target="_blank" rel="noreferrer">
                        <img className="round" src={datacampDEAssociateBadge} alt="Datacamp Associate Data Engineer Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://www.credly.com/badges/cc8d977e-9714-47ca-8d95-71bf6d78f0db/public_url" target="_blank" rel="noreferrer">
                        <img src={dp900Badge} alt="DP900 Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://www.credly.com/badges/ae32c35b-72ea-4113-bdcc-cb219be9773a" target="_blank" rel="noreferrer">
                        <img src={az900Badge} alt="AZ900 Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://www.credly.com/badges/4151855b-3fbd-4340-ac9b-d0fbff8e9404/public_url" target="_blank" rel="noreferrer">
                        <img src={aiKnowledgeMiningBadge} alt="OpenHack: AI-Powered Knowledge Mining Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                </section>

                <section className="badges second-row">
                    <a href="https://developerbadges.snowflake.com/c1f3768c-e462-458f-9f6a-092fe5dffe84#acc.r8QtfmYF" target="_blank" rel="noreferrer">
                        <img src={snowflakeGenAIBadge} alt="Snowflake Gen AI Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://www.credly.com/badges/bc603fa3-3d2f-486f-8681-83abe267e41b" target="_blank" rel="noreferrer">
                        <img src={awsBadge} alt="AWS Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                    <a href="https://openbadgepassport.com/app/badge/info/410046" target="_blank" rel="noreferrer">
                        <img src={hhBadge} alt="HH Badge" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                </section>


                <section className="badges third-row">
                    <a href="https://cs50.harvard.edu/certificates/324dd64c-48e7-4f31-afab-ed2814a07a57" target="_blank" rel="noreferrer">
                        <img className="round" src={readyPlayer50Badge} alt="Ready Player 50" width="100px" height="100px" />
                        {/* <p>hidden</p> */}
                    </a>
                </section>
            </article>
        </Container>
    )
}
